import moment, { Moment } from 'moment';

// 定义接口
export interface DateShortcutType {
  name: string;
  nameCN: string;
  onClick: () => Array<Moment | null>;
}

export interface ShortcutOptionType {
  [type: string]: DateShortcutType[];
}

// startOfTime和latestDate，不是所有地方都需要，需要从外部传入参数
export const shortcutOption = (startOfTime: string, latestDate: any): ShortcutOptionType => {

  const { date, month, week } = latestDate;

  const latestDataObj = {
    name: 'Latest Data',
    nameCN: '最新数据',
  };
  const allOfTimeObj = {
    name: 'All of time',
    nameCN: '所有时间',
  };

  const latestDateData = {
    ...latestDataObj,
    onClick: () => {
      return [moment(date), moment(date)];
    }
  };
  const latestWeekData = {
    ...latestDataObj,
    onClick: () => {
      return [moment(week).weekday(0), moment(week).weekday(6)];
    }
  };
  const latestMonthData = {
    ...latestDataObj,
    onClick: () => {
      return [moment(month).subtract(0, 'month').startOf('month'), moment(month).subtract(0, 'month').endOf('month')];
    }
  };

  const allDateOfTime = {
    ...allOfTimeObj,
    onClick: () => {
      return [moment(startOfTime), moment()];
    }
  };
  const allWeekOfTime = {
    ...allOfTimeObj,
    onClick: () => {
      return [moment(startOfTime).startOf('week'), moment().weekday(6)];
    }
  };
  const allMonthOfTime = {
    ...allOfTimeObj,
    onClick: () => {
      return [moment(startOfTime), moment().endOf('month')];
    }
  };

  let dateArray = [
    {
      name: 'Last 7 Days',
      nameCN: '最近7天',
      onClick: () => {
        return [moment().subtract(7, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 30 Days',
      nameCN: '最近30天',
      onClick: () => {
        return [moment().subtract(30, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 90 Days',
      nameCN: '最近90天',
      onClick: () => {
        return [moment().subtract(90, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 180 Days',
      nameCN: '最近180天',
      onClick: () => {
        return [moment().subtract(180, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Last 365 Days',
      nameCN: '最近365天',
      onClick: () => {
        return [moment().subtract(365, 'day'), moment().subtract(1, 'day')];
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => {
        return [moment().startOf('year'), moment()];
      }
    },
  ];

  let weekArray = [
    {
      name: 'Last 4 Weeks',
      nameCN: '最近4周',
      onClick: () => {
        return [moment().weekday(-7 * 4), moment().weekday(-1)];
      }
    },
    {
      name: 'Last 12 Weeks',
      nameCN: '最近12周',
      onClick: () => {
        return [moment().weekday(-7 * 12), moment().weekday(-1)];
      }
    },
    {
      name: 'Last 24 Weeks',
      nameCN: '最近24周',
      onClick: () => {
        return [moment().weekday(-7 * 24), moment().weekday(-1)];
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => {
        // 取末尾为本周日，如果语言环境修改了每周的起始时间（moment.locale(）），则需重新修改
        return [moment().startOf('year').startOf('week'), moment().weekday(6)];
      }
    },
  ];

  let monthArray = [
    {
      name: 'Last 3 Months',
      nameCN: '最近3个月',
      onClick: () => {
        return [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      }
    },
    {
      name: 'Last 6 Months',
      nameCN: '最近6个月',
      onClick: () => {
        return [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      }
    },
    {
      name: 'Last 12 Months',
      nameCN: '最近12个月',
      onClick: () => {
        return [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      }
    },
    {
      name: 'Last 24 Months',
      nameCN: '最近24个月',
      onClick: () => {
        return [moment().subtract(24, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => {
        return [moment().startOf('year'), moment().endOf('month')];
      }
    },
  ];

  if (JSON.stringify(latestDate) !== '{}') {
    dateArray = [latestDateData, ...dateArray];
    weekArray = [latestWeekData, ...weekArray];
    monthArray = [latestMonthData, ...monthArray];
  }
  if (startOfTime != '') {
    dateArray = [...dateArray, allDateOfTime];
    weekArray = [...weekArray, allWeekOfTime];
    monthArray = [...monthArray, allMonthOfTime];
  }

  return {
    'date': dateArray,
    'week': weekArray,
    'month': monthArray,
  };
};

